import React, { FormEvent, useCallback } from "react";
import { useCloud } from "./CloudProvider.js";
import { Alert } from "../../../packages/ui/Alert.js";
import { Form } from "../../../packages/ui/form/Form.js";
import { Dialog } from "../../../packages/ui/Dialog.js";
import { FormRow } from "../../../packages/ui/form/FormRow.js";
import { FilesInput } from "../../../packages/ui/form/FilesInput.js";
import { Buttons } from "../../../packages/ui/form/Buttons.js";
import { Button } from "../../../packages/ui/button/Button.js";
import { formatProgress } from "./formatProgress.js";
import { Input } from "../../../packages/ui/form/Input.js";
import { isSyncDirectory } from "./isSyncDirectory.js";

/**
 * Displays a form to upload new files to the cloud and to create
 * new directories.
 */
export const CloudForm = () => {
  const {
    uploadError,
    isUploading,
    uploadFiles,
    filesInputKey,
    cancelUpload,
    progress,
    directoryError,
    createDirectory,
    directory,
    directoryName,
    setDirectoryName
  } = useCloud();

  const handleDirectorySubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      createDirectory();
    },
    [createDirectory]
  );

  if (isSyncDirectory(directory)) {
    return null;
  }

  return (
    <div className="cloud-form">
      <Form onSubmit={handleDirectorySubmit}>
        <FormRow columns={1}>
          <FilesInput label="Upload files" onChange={uploadFiles} inputKey={filesInputKey} />
        </FormRow>
        <FormRow columns={1}>
          <Input
            label="New directory name"
            value={directoryName}
            onChange={setDirectoryName}
            error={directoryError}
          />
        </FormRow>
        <FormRow columns={1}>
          <Buttons>
            <Button type="submit">Create</Button>
          </Buttons>
        </FormRow>
      </Form>
      {uploadError && <Alert type="error">{uploadError}</Alert>}
      <Form>
        {isUploading && (
          <Dialog>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <div className="text-small">
                Files are being uploaded ... <br />
                {progress ? formatProgress(progress) : ""}
              </div>
              <Buttons>
                <Button onClick={cancelUpload}>Cancel</Button>
              </Buttons>
            </div>
          </Dialog>
        )}
      </Form>
    </div>
  );
};
